const contactTopics = [
	{
		htmlText: 'General Inquiry about ASA24 Researcher Website',
		trueValue: 'GENERAL_RESEARCHER'
	},
	{
		htmlText: 'General Inquiry about ASA24',
		trueValue: 'GENERAL_ASA24'
	},
	{
		htmlText: 'Feedback about ASA24',
		trueValue: 'FEEDBACK_ASA24'
	},
	{
		htmlText: 'Report a Bug',
		trueValue: 'BUG'
	},
	{
		htmlText: 'Need Help With ASA24',
		trueValue: 'HELP'
	},
	{
		htmlText: 'Accessibility',
		trueValue: 'ACCESSIBILITY'
	}
]

const contactWebsites = [
	{
		htmlText: 'Respondent Web site (English)',
		trueValue: 'RESPONDENT_ENG'
	},
	{
		htmlText: 'Respondent Web site (Spanish)',
		trueValue: 'RESPONDENT_SPA'
	},
	{
		htmlText: 'Researcher Web site',
		trueValue: 'RESEARCHER'
	}
]

const contactVersionTypes = [
	{
		htmlText: 'ASA24-2022',
		trueValue: 'VERSION_2022'
	},
	{
		htmlText: 'ASA24-2020',
		trueValue: 'VERSION_2020'
	},
	{
		htmlText: 'ASA24-2018',
		trueValue: 'VERSION_2018'
	},
	{
		htmlText: 'ASA24-Canada-2018',
		trueValue: 'VERSION_CAN_2018'
	},
	{
		htmlText: 'ASA24-Australia-2016',
		trueValue: 'VERSION_AUS_2016'
	}
]

const contactOperatingSystems = [
	{
		htmlText: 'Windows',
		trueValue: 'WINDOWS'
	},
	{
		htmlText: 'MacOS',
		trueValue: 'MAC'
	},
	{
		htmlText: 'iPhone',
		trueValue: 'IPHONE'
	},
	{
		htmlText: 'Android',
		trueValue: 'ANDROID'
	},
	{
		htmlText: 'Other',
		trueValue: 'OTHER'
	}
]

const contactBrowsers = [
	{
		htmlText: 'Chrome',
		trueValue: 'CHROME'
	},
	{
		htmlText: 'FireFox',
		trueValue: 'FIREFOX'
	},
	{
		htmlText: 'Edge',
		trueValue: 'EDGE'
	},
	{
		htmlText: 'Safari',
		trueValue: 'SAFARI'
	},
	{
		htmlText: 'Other',
		trueValue: 'OTHER'
	}
]

const contactHelpTopics = [
	{
		htmlText: 'Registering a Study',
		trueValue: 'STUDY_REGISTER'
	},
	{
		htmlText: 'Editing Study Settings',
		trueValue: 'STUDY_EDIT'
	},
	{
		htmlText: 'Uploading Respondents',
		trueValue: 'RESPONDENTS_UPLOAD'
	},
	{
		htmlText: 'Tracking Respondent Progress',
		trueValue: 'RESPONDENTS_TRACKING'
	},
	{
		htmlText: 'Accounts/Logging in/Passwords',
		trueValue: 'ACCOUNTS'
	},
	{
		htmlText: 'Respondent access to Respondent Web site',
		trueValue: 'RESPONDENTS_ACCESS'
	},
	{
		htmlText: 'Obtaining Analysis',
		trueValue: 'ANALYSIS'
	},
	{
		htmlText: 'Other',
		trueValue: 'OTHER'
	}
]

export default {
	contactTopics,
	contactWebsites,
	contactVersionTypes,
	contactOperatingSystems,
	contactBrowsers,
	contactHelpTopics
}
